import { create } from "zustand";
import type { Product } from "./data/products.ts";

interface CartItem { product: Product; qty: number }
interface CartState {
  items: CartItem[];
  add: (p: Product) => void;
  remove: (id: number) => void;
}

export const useCart = create<CartState>((set) => ({
  items: [],
  add: (p) => set((s) => {
    const hit = s.items.find((i) => i.product.id === p.id);
    return { items: hit ? s.items.map((i) => (i.product.id === p.id ? { ...i, qty: i.qty + 1 } : i)) : [...s.items, { product: p, qty: 1 }] };
  }),
  remove: (id) => set((s) => ({ items: s.items.filter((i) => i.product.id !== id) })),
}));
